import { request } from '@/api/index';
export function getDetail(data) {
  return request({
    url: '/api/Task/GetTask',
    method: 'get',
    params: data
  });
}